import classNames from 'classnames';
import isString from 'lodash/isString';
import React, { Component } from 'react';

import { WrappedButton, WrappedButtonType } from '../ui/button';
import { BasePanel } from './BasePanel.component';
import { LayoutContext } from './LayoutContext';
import { RegionType } from './RegionType.enum';
import { Splitter } from './Splitter.component';

export class CollapsibleSidePanel extends Component {
	togglePanel = () => {
		const { region } = this.props;
		const { collapseSidePanel } = this.context;

		collapseSidePanel(region);
	};

	render() {
		const { className, region, title, children, hideCollapsibleButton } =
			this.props;
		const { getLayout } = this.context;
		const regionLayout = getLayout(region) || {};
		const {
			isCollapsed = false,
			resizable = true,
			isHidden = false,
		} = regionLayout;
		const panelCls = classNames(`common-layout collapsible-panel`, {
			'east-collapsible-panel': region === RegionType.East,
			'west-collapsible-panel': region === RegionType.West,
			expanded: isCollapsed !== true,
			collapsed: isCollapsed === true,
			resizable: resizable === true,
			[className]: isString(className) && className !== '',
		});

		if (isHidden) {
			return null;
		}

		return (
			<>
				<BasePanel className={panelCls} region={region}>
					<div className="collapsible-panel-body">
						{children}
						{!hideCollapsibleButton && (
							<WrappedButton
								buttonType={WrappedButtonType.Icon}
								className="collapse-toggle-button"
								onClick={this.togglePanel}
								icon="collapsible-panel-toggle-icon collapse"
								dataqa="collapsible-toggle-btn"
								tooltip="Collapse this panel."
							/>
						)}
					</div>

					<div
						className="collapsible-panel-header"
						onClick={this.togglePanel}
						role="presentation"
					>
						<div className="collapsible-panel-header-title-wrapper">
							<WrappedButton
								buttonType={WrappedButtonType.Icon}
								className="collapse-toggle-button"
								icon="collapsible-panel-toggle-icon expand"
								dataqa="collapsible-toggle-btn"
								tooltip="Expand this panel."
							/>
							<span
								className="collapsible-panel-header-title"
								data-qa="collapsible-header-title"
								{...{ dataqa: 'collapsible-header-title' }}
							>
								{title}
							</span>
						</div>
					</div>
				</BasePanel>

				{resizable === true && isCollapsed !== true && (
					<Splitter
						className={className}
						region={region}
						layout={regionLayout}
						layoutContext={this.context}
					/>
				)}
			</>
		);
	}
}

CollapsibleSidePanel.contextType = LayoutContext;
